module.exports = __webpack_public_path__ + "img/744.f7703256.jpg";